
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/collab",
      function () {
        return require("private-next-pages/features/collab.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/collab"])
      });
    }
  